// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const startLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen container-x py-32">
      <div className="max-w-md">
        <div className="eyebrow">Restricted Access</div>
        <h1 className="font-display text-5xl mt-6 text-[#0F172A] leading-none">Attorney portal.</h1>
        <p className="mt-6 text-[#4A4D50] leading-relaxed">
          Sign in with your firm-authorized Google account to manage case review submissions and success stories.
        </p>
        <button
          onClick={startLogin}
          data-testid="google-login-btn"
          className="mt-10 btn-primary"
        >
          <LogIn size={18} /> Continue with Google
        </button>
        <p className="mt-8 font-mono-plex text-xs text-[#4A4D50]">
          Access is limited to email addresses on the firm's admin allowlist.
        </p>
      </div>
    </div>
  );
}
